export default __webpack_public_path__ + "slices/main/assets/public/media/home/homepage-science@2x.b6e99a7ecdbb8df98c4690c4ec24a3c8.png";